import { useState } from 'react';

export interface Credentials {
    email: string;
    password: string;
}

const initialCredentials: Credentials = { email: '', password: '' }

export const useLoginInput = (): { setCredentials: (name: keyof Credentials, value: string) => void, credentials: Credentials } => {
    const [credentials, updateCredentials] = useState(initialCredentials)

    const setCredentials = (name: keyof Credentials, value: string) => {
        updateCredentials({
            ...credentials,
            [name]: value
        })
    }

    return { setCredentials, credentials };
};
